import React from "react";
import { RefreshCw } from "lucide-react";

/**
 * The site title + tagline + manual refresh action that opens the dashboard.
 * Kept dumb on purpose: the parent owns reload state and passes it as a prop.
 */
export default function DashboardHeader({ site, days, onRefresh }) {
  const today = new Date().toLocaleDateString("en-GB", {
    weekday: "long", day: "numeric", month: "long",
  });

  return (
    <header className="flex flex-col sm:flex-row sm:items-end justify-between gap-3">
      <div>
        <div className="label-tiny mb-2">Live overview · {days} day window</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight">
          {site.name}
        </h1>
        <div className="text-sm text-muted-foreground mt-1" data-testid="dashboard-tagline">
          {site.location_name || "—"} · {today}
        </div>
      </div>
      <button
        onClick={onRefresh}
        className="self-start sm:self-auto inline-flex items-center gap-1.5 px-3 py-2 rounded-md border border-border text-xs hover:bg-secondary"
        data-testid="dashboard-refresh"
      >
        <RefreshCw className="w-3.5 h-3.5" /> Refresh
      </button>
    </header>
  );
}
